import { amenitiesByCode, amenitiesInfo } from "@/info/amenities";
import { cn } from "@/utils/cn";
import Image from "next/image";
import type { FC } from "react";
import { useMemo } from "react";

type AmenityIconProps = {
	code?: string;
	type?: string;
	className?: string;
	alt?: string;
};

export const AmenityIcon: FC<AmenityIconProps> = ({ code, type: icon, className = "w-4 h-4", alt }) => {
	const iconPath = useMemo(() => {
		if (icon) return icon;
		if (code) {
			const found = amenitiesByCode.get(code)?.icon;
			if (found) return found;
		}
		return amenitiesInfo[0]?.icon || null;
	}, [icon, code]);

	const srcPath = iconPath ? `/images/${iconPath}.svg` : "";
	// todo later: add the placeholder icon if srcPath is empty

	const friendlyName = alt || (code ? amenitiesByCode.get(code)?.name || code : "Amenity icon");

	// Extract numeric size from className (default 16px)
	const match = className.match(/w-(\d+)/);
	const sizeNum = match ? parseInt(match[1], 10) * 4 : 16;

	return (
		<div className={cn("flex items-center justify-center", className)}>
			<Image
				src={srcPath}
				alt={friendlyName}
				width={sizeNum}
				height={sizeNum}
				className={cn("object-contain", className, "text-primary")}
				priority={false}
				draggable={false}
			/>
		</div>
	);
};
